@switch (state) {
  @case ('loading') {
    <section class="seo-hero seo-hero--loading">
      <div class="seo-hero__container">
        <div class="skeleton-line skeleton-line--hero-title"></div>
        <div class="skeleton-line skeleton-line--hero-title skeleton-line--narrow"></div>
        <div class="skeleton-line skeleton-line--hero-lead"></div>
        <div class="skeleton-line skeleton-line--hero-lead"></div>
        <div class="skeleton-line skeleton-line--hero-lead skeleton-line--narrow"></div>
      </div>
      <svg class="hero-wave" viewBox="0 0 1440 120" preserveAspectRatio="none" aria-hidden="true" focusable="false">
        <path d="M0,40 C240,100 480,0 720,40 C960,80 1200,20 1440,60 L1440,120 L0,120 Z" fill="#ffffff"></path>
      </svg>
    </section>
    <article class="seo-page seo-page--loading">
      <div class="skeleton-section">
        <div class="skeleton-line skeleton-line--eyebrow"></div>
        <div class="skeleton-line skeleton-line--section-title"></div>
        <div class="skeleton-line skeleton-line--body"></div>
        <div class="skeleton-line skeleton-line--body"></div>
        <div class="skeleton-line skeleton-line--body skeleton-line--narrow"></div>
      </div>
      <div class="skeleton-section">
        <div class="skeleton-line skeleton-line--eyebrow"></div>
        <div class="skeleton-line skeleton-line--section-title"></div>
        <div class="skeleton-line skeleton-line--body"></div>
        <div class="skeleton-line skeleton-line--body skeleton-line--narrow"></div>
      </div>
    </article>
  }
  @case ('not-found') {
    <section class="seo-hero seo-hero--error">
      <div class="seo-hero__container">
        <h1 class="seo-hero__title">Pagina niet gevonden</h1>
        <div class="seo-hero__lead">Deze pagina bestaat niet of is verplaatst.</div>
      </div>
      <svg class="hero-wave" viewBox="0 0 1440 120" preserveAspectRatio="none" aria-hidden="true" focusable="false">
        <path d="M0,40 C240,100 480,0 720,40 C960,80 1200,20 1440,60 L1440,120 L0,120 Z" fill="#ffffff"></path>
      </svg>
    </section>
    <article class="seo-page seo-page--error">
      <a class="btn btn--primary" routerLink="/">Naar homepage</a>
    </article>
  }
  @case ('error') {
    <section class="seo-hero seo-hero--error">
      <div class="seo-hero__container">
        <h1 class="seo-hero__title">Tijdelijk niet beschikbaar</h1>
        <div class="seo-hero__lead">{{ errorMessage }}</div>
      </div>
      <svg class="hero-wave" viewBox="0 0 1440 120" preserveAspectRatio="none" aria-hidden="true" focusable="false">
        <path d="M0,40 C240,100 480,0 720,40 C960,80 1200,20 1440,60 L1440,120 L0,120 Z" fill="#ffffff"></path>
      </svg>
    </section>
    <article class="seo-page seo-page--error">
      <button class="btn btn--primary" (click)="retry()">Probeer opnieuw</button>
    </article>
  }
  @case ('ok') {
    @if (detail) {
      <section class="seo-hero" [style.--seo-hero-bg]="heroBgCss">
        <div class="seo-hero__container">
          <h1 class="seo-hero__title">{{ detail.intro.title }}</h1>
          @if (detail.intro.text) {
            <div class="seo-hero__lead" [innerHTML]="detail.intro.text"></div>
          }
          @if (detail.cta.secondaryButton) {
            <div class="seo-hero__actions">
              @if (secondaryCtaRouterLink) {
                <a class="btn btn--primary seo-hero__cta" [routerLink]="secondaryCtaRouterLink">
                  {{ detail.cta.secondaryButton.label }}
                </a>
              } @else if (secondaryCtaExternalHref) {
                <a class="btn btn--primary seo-hero__cta" [href]="secondaryCtaExternalHref" rel="noopener">
                  {{ detail.cta.secondaryButton.label }}
                </a>
              }
            </div>
          }
        </div>

        <svg class="hero-orb orb-a" viewBox="0 0 400 400" aria-hidden="true" focusable="false">
          <defs>
            <radialGradient id="seoOrbGradientA" cx="50%" cy="50%" r="50%">
              <stop offset="0%" stop-color="#75b6e7" stop-opacity="0.6"/>
              <stop offset="100%" stop-color="#75b6e7" stop-opacity="0"/>
            </radialGradient>
          </defs>
          <circle cx="200" cy="200" r="200" fill="url(#seoOrbGradientA)"/>
        </svg>
        <svg class="hero-orb orb-b" viewBox="0 0 400 400" aria-hidden="true" focusable="false">
          <defs>
            <radialGradient id="seoOrbGradientB" cx="50%" cy="50%" r="50%">
              <stop offset="0%" stop-color="#ffffff" stop-opacity="0.35"/>
              <stop offset="100%" stop-color="#ffffff" stop-opacity="0"/>
            </radialGradient>
          </defs>
          <circle cx="200" cy="200" r="200" fill="url(#seoOrbGradientB)"/>
        </svg>

        <svg class="hero-wave" viewBox="0 0 1440 120" preserveAspectRatio="none" aria-hidden="true" focusable="false">
          <path d="M0,40 C240,100 480,0 720,40 C960,80 1200,20 1440,60 L1440,120 L0,120 Z" fill="#ffffff"></path>
        </svg>
      </section>

      <article class="seo-page" [attr.data-seo-document]="detail.documentId">

        @if (detail.children.length > 0) {
          <!-- BLA-54: published direct children in navigation order; omitted when there are none. -->
          <section class="seo-page__section seo-page__section--children" aria-labelledby="seo-children-heading">
            <header class="seo-page__section-head">
              <h2 id="seo-children-heading" class="seo-page__section-title">{{ childrenHeading }}</h2>
            </header>
            <ul class="m-0 grid list-none grid-cols-1 gap-3 p-0 md:grid-cols-2 lg:grid-cols-3" data-testid="seo-children">
              @for (child of detail.children; track trackChild($index, child)) {
                <li class="m-0 p-0">
                  <a
                    class="group flex min-h-14 items-center justify-between gap-3 rounded-2xl border border-slate-200 bg-white px-5 py-4 font-medium text-slate-900 no-underline transition-colors duration-150 hover:border-[#1f6fb2] hover:text-[#1f6fb2] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1f6fb2]"
                    [routerLink]="child.path"
                    >
                    <span class="min-w-0 [overflow-wrap:anywhere]">{{ child.label }}</span>
                    <icon name="navigate_next" class="seo-page__child-arrow shrink-0 text-[#1f6fb2] transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true"></icon>
                  </a>
                </li>
              }
            </ul>
          </section>
        }

        <section class="seo-page__section">
          <header class="seo-page__section-head">
            <span class="seo-page__section-eyebrow">{{ detail.cta.eyebrow }}</span>
            @if (detail.cta.title) {
              <h2 class="seo-page__section-title">{{ detail.cta.title }}</h2>
            }
          </header>
          <div class="quick-apply">
            @if (detail.cta.text) {
              <p class="quick-apply__text">{{ detail.cta.text }}</p>
            }
            <div class="quick-apply__actions">
              @if (ctaRouterLink) {
                <a class="btn btn--primary" [routerLink]="ctaRouterLink">
                  {{ detail.cta.buttonLabel }}
                </a>
              } @else if (ctaExternalHref) {
                <a class="btn btn--primary" [href]="ctaExternalHref" rel="noopener">
                  {{ detail.cta.buttonLabel }}
                </a>
              }
            </div>
          </div>
        </section>

        @if (detail.body.blocks.length > 0) {
          <section class="seo-page__section seo-page__section--body">
            <span class="seo-page__section-eyebrow">{{ detail.body.eyebrow }}</span>
            <div class="seo-page__body">
              @for (block of detail.body.blocks; track trackContentBlock($index, block)) {
                @if (block.type === 'paragraph') {
                  <app-blog-block-paragraph
                    class="seo-page__content-block"
                    [block]="block">
                  </app-blog-block-paragraph>
                }
                @if (block.type === 'image') {
                  <app-blog-block-image
                    class="seo-page__content-block"
                    [block]="block">
                  </app-blog-block-image>
                }
              }
            </div>
          </section>
        }

        <section class="seo-page__section">
          <header class="seo-page__section-head">
            <span class="seo-page__section-eyebrow">{{ detail.vacancyBlock.eyebrow }}</span>
            <h2 class="seo-page__section-title">{{ detail.vacancyBlock.title }}</h2>
          </header>
          @if (hasVacancies) {
            <div class="vacancy-rows">
              <app-featured-jobs-list
                [jobs]="detail.vacancyBlock.jobs"
                [title]="''">
              </app-featured-jobs-list>
            </div>
            @if (vacancyCtaRouterLink) {
              <a class="btn btn--primary" [routerLink]="vacancyCtaRouterLink">
                {{ detail.vacancyBlock.cta.label }}
              </a>
            } @else if (vacancyCtaExternalHref) {
              <a class="btn btn--primary" [href]="vacancyCtaExternalHref" rel="noopener">
                {{ detail.vacancyBlock.cta.label }}
              </a>
            }
          } @else {
            <div class="seo-page__empty-vacancies">
              <p>{{ detail.vacancyBlock.empty.text }}</p>
              @if (emptyVacanciesCtaRouterLink) {
                <a class="btn btn--primary" [routerLink]="emptyVacanciesCtaRouterLink">
                  {{ detail.vacancyBlock.empty.ctaLabel }}
                </a>
              } @else if (emptyVacanciesCtaExternalHref) {
                <a class="btn btn--primary" [href]="emptyVacanciesCtaExternalHref" rel="noopener">
                  {{ detail.vacancyBlock.empty.ctaLabel }}
                </a>
              }
            </div>
          }
        </section>

        @if (detail.faq.items.length > 0) {
          <section class="seo-page__section">
            <header class="seo-page__section-head">
              <span class="seo-page__section-eyebrow">{{ detail.faq.eyebrow }}</span>
              <h2 class="seo-page__section-title">{{ detail.faq.title }}</h2>
            </header>
            <div class="faq-grid">
              <app-faq-block
                [title]="''"
                [items]="detail.faq.items">
              </app-faq-block>
            </div>
          </section>
        }

        @if (detail.blogs.cards.length > 0) {
          <section class="seo-page__section">
            <header class="seo-page__section-head">
              <span class="seo-page__section-eyebrow">{{ detail.blogs.eyebrow }}</span>
              <h2 class="seo-page__section-title">{{ detail.blogs.title }}</h2>
            </header>
            <div class="seo-page__blogs-grid">
              @for (blog of detail.blogs.cards; track blog.slug) {
                <a class="seo-page__blog-card" [routerLink]="['/stories', blog.slug]">
                  @if (blog.coverImageUrl) {
                    <img [src]="blog.coverImageUrl" [alt]="blog.title" loading="lazy" />
                  }
                  <h3>{{ blog.title }}</h3>
                  @if (blog.excerpt) {
                    <p>{{ blog.excerpt }}</p>
                  }
                </a>
              }
            </div>
          </section>
        }

        @if (detail.relatedPages.pages.length > 0) {
          <section class="seo-page__section">
            <header class="seo-page__section-head">
              <span class="seo-page__section-eyebrow">{{ detail.relatedPages.eyebrow }}</span>
              <h2 class="seo-page__section-title">{{ detail.relatedPages.title }}</h2>
            </header>
            <ul class="seo-page__related-list">
              @for (p of detail.relatedPages.pages; track trackRelated($index, p)) {
                <li>
                  <a [routerLink]="p.path">
                    <span class="seo-page__related-title">{{ p.title }}</span>
                  </a>
                </li>
              }
            </ul>
          </section>
        }

        @if ((detail.bottomBody?.blocks?.length ?? 0) > 0) {
          <section class="seo-page__section seo-page__section--bottom-body">
            <div class="seo-page__body">
              @for (block of (detail.bottomBody?.blocks ?? []); track trackContentBlock($index, block)) {
                @if (block.type === 'paragraph') {
                  <app-blog-block-paragraph
                    class="seo-page__content-block"
                    [block]="block">
                  </app-blog-block-paragraph>
                }
                @if (block.type === 'image') {
                  <app-blog-block-image
                    class="seo-page__content-block"
                    [block]="block">
                  </app-blog-block-image>
                }
              }
            </div>
          </section>
        }
      </article>
    }
  }
}
